import React from "react";

import { useToast } from "./use-toast";

type Props<T> = { request: () => Promise<T[]> };

export const useFetchList = <T>({ request }: Props<T>) => {
  const { handleFirebaseError } = useToast();

  const [data, setData] = React.useState<T[]>([]);
  const [loading, setLoading] = React.useState(true);

  const firebaseFetch = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await request();

      setData(response);
    } catch (error) {
      handleFirebaseError(error);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);

  React.useEffect(() => {
    void firebaseFetch();
  }, [firebaseFetch]);

  return { loading, data } as const;
};
